interface UserLike {
  id: string;
  username?: string | null;
  firstName: string;
  lastName: string;
}

/**
 * Generates a unique display name for users who haven't chosen a username yet
 * Format: "FirstName L. #XXXX" (e.g., "Gordon S. #a1b2")
 * Fallback: "Learner #XXXX" if names are missing
 */
export function getDisplayName(user: UserLike): string {
  if (user.username) {
    return user.username;
  }
  
  // Generate unique suffix from user ID (last 4 chars)
  const uniqueSuffix = user.id.slice(-4);
  
  // Handle missing or empty names
  const firstName = user.firstName?.trim();
  const lastName = user.lastName?.trim();
  
  if (!firstName && !lastName) {
    return `Learner #${uniqueSuffix}`;
  }
  
  if (!firstName) {
    return `${lastName} #${uniqueSuffix}`;
  }
  
  if (!lastName) {
    return `${firstName} #${uniqueSuffix}`;
  }
  
  // Generate temporary name from first name + last initial + unique suffix
  const lastInitial = lastName.charAt(0).toUpperCase();
  return `${firstName} ${lastInitial}. #${uniqueSuffix}`;
}

/**
 * Check if user has set a custom username
 */
export function hasCustomUsername(user: Pick<UserLike, 'username'>): boolean {
  return !!user.username;
}
